import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url/dist/src/constants';
import { ThemeOptions } from '../../../publicSession/types';
import CoreIconSmall from '../../../Icons/CoreIconSmall';
import CheckIcon from './GradientCheckIcon';
import LoadingIndicator from '../../../LoadingIndicator';
import { IconSize } from '../../../Icons/IconWrap';
import BiButton from '../../../biLogger/Components/BiButton';
import { BiEventType } from '../../../biLogger/constants';
import { DEFAULT_BACKGROUND_ID } from '../../redux/constants';
import s from './BackgroundThumb.scss';
var BackgroundThumb = /** @class */ (function (_super) {
    tslib_1.__extends(BackgroundThumb, _super);
    function BackgroundThumb() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.startPreview = function () {
            var _a = _this.props, backgroundId = _a.background.backgroundId, onBackgroundPreviewed = _a.onBackgroundPreviewed;
            onBackgroundPreviewed(backgroundId);
        };
        _this.endPreview = function () {
            _this.props.onBackgroundPreviewed();
        };
        _this.pick = function () {
            var _a = _this.props, _b = _a.background, backgroundId = _b.backgroundId, isPremium = _b.isPremium, onBackgroundPicked = _a.onBackgroundPicked, canUseCore = _a.canUseCore;
            if (isPremium && !canUseCore) {
                return;
            }
            onBackgroundPicked(backgroundId);
        };
        return _this;
    }
    BackgroundThumb.prototype.render = function () {
        var _a = this.props, _b = _a.background, lightThumbUrl = _b.lightThumbUrl, darkThumbUrl = _b.darkThumbUrl, isPremium = _b.isPremium, _c = _b.backgroundId, backgroundId = _c === void 0 ? DEFAULT_BACKGROUND_ID : _c, canUseCore = _a.canUseCore, isSelected = _a.isSelected, isLoading = _a.isLoading, theme = _a.theme, t = _a.t;
        var src = theme === ThemeOptions.LIGHT ? lightThumbUrl : darkThumbUrl;
        var isDefault = backgroundId < 0;
        return (React.createElement(BiButton, { className: classnames(s['root'], isPremium && !canUseCore && s['core'], isSelected && s['selected'], isDefault && s["default-" + theme], theme && s["thumb-theme-" + theme]), style: {
                backgroundImage: src ? "url('" + src + "')" : undefined,
            }, onMouseEnter: this.startPreview, onMouseLeave: this.endPreview, onClick: this.pick, biData: {
                evid: BiEventType.SELECT_BACKGROUND,
                background_id: backgroundId,
            } },
            isPremium && (React.createElement(CoreIconSmall, { size: IconSize.SMALL, className: s['core-icon'] })),
            isSelected && !isLoading && React.createElement(CheckIcon, { className: s['check-icon'] }),
            isDefault && (React.createElement("div", { className: s['text'] }, t('deviation.backgrounds.original'))),
            isPremium && !canUseCore && (React.createElement("div", { className: s['text'] },
                React.createElement("a", { href: URLS.CORE_MEMBERSHIP }, t('deviation.backgrounds.buyCore')))),
            isLoading && React.createElement(LoadingIndicator, { className: s['loader'] }),
            ' '));
    };
    return BackgroundThumb;
}(React.Component));
export { BackgroundThumb };
export default withTranslation()(BackgroundThumb);
//# sourceMappingURL=BackgroundThumb.js.map